export default {
  login: { id: 'login' },
  email: { id: 'email' },
  emailOrUsername: { id: 'email_or_username' },
  password: { id: 'password' },
  forgot_password: { id: 'forgot_password' },
  remember_me: { id: 'remember_me' },
  contact_us: { id: 'contact_us' },
}
